import * as React from 'react';
import {cva} from 'class-variance-authority';
import {twMerge} from 'tailwind-merge';

const containerVariants = cva('relative flex items-center justify-center w-8 h-8 mr-1');

const bgVariants = cva('absolute inset-0 border rounded transition-all');

const iconVariants = cva('relative z-10 transition-all');

export default function ResourceFigure({
	icon: Icon,
	iconSize = 18,
	className,
	bgClassName,
	iconClassName,
}) {
	return (
		<div className={twMerge(containerVariants(), className)}>
			<div className={twMerge(bgVariants(), bgClassName)} />
			<Icon
				className={twMerge(iconVariants(), iconClassName)}
				size={iconSize}
				strokeWidth={1.5}
			/>
		</div>
	);
}
